import { Box, Typography } from "@mui/material"
import { RadioAndResponseForm, RadioOption } from "../../flows/shared/RadioAndResponseForm"
import MuiMarkdown from "mui-markdown"
import { ProbateField, SelectOption } from "../../../models/ProbateField"
import { SingleTextForm } from "../../flows/shared/SingleTextForm"
import { SingleDateForm } from "../../flows/shared/SingleDateForm"
import React, { useState } from "react"
import AtticusDrawer from "views/shared/drawer/AtticusDrawer"
interface Props {
  field: ProbateField
  onAnswer: (answer: string | number | boolean) => Promise<void>
}

export const ProbateFieldQuestion = ({ field, onAnswer }: Props): JSX.Element => {
  const [isLearnMoreVisible, setIsLearnMoreVisible] = useState<boolean>(false)

  const openLearnMore = () => {
    setIsLearnMoreVisible(true)
  }
  const closeLearnMore = () => {
    setIsLearnMoreVisible(false)
  }

  const header = <Typography variant="h5">{field.question}</Typography>
  let form: JSX.Element | null = null
  switch (field.interfaceType) {
    case "boolean":
      form = (
        <RadioAndResponseForm
          initAnswer={field.answer}
          answerLabel={field.question}
          options={[{ value: "Yes" }, { value: "No" }]}
          onComplete={async (answer: string): Promise<boolean> => {
            await onAnswer(ProbateField.getBooleanValue(answer))
            return true
          }}
          centerButtons={true}
        />
      )
      break
    case "string":
    case "currency":
    case "currency_negative":
    case "number":
    case "number_negative": {
      form = (
        <SingleTextForm
          initText={field.answerValue ? field.answerValue.toString() : undefined}
          isNumber
          // inputMatches={inputMatches}
          // errorText="Please enter estimated fair market value or let us know if you're not sure"
          textLabel={field.question}
          onComplete={async (answer: string): Promise<boolean> => {
            await onAnswer(field.interfaceType === "number" ? parseFloat(answer) : answer)
            return true
          }}
          prefix={field.prefix}
          // onBack={() => setQuestionComponent(undefined)}
          // inputComponent={NumberFormatCustom}
          // noneTextOption="I’m not sure"
          centerButtons={true}
        />
      )
      break
    }
    case "date": {
      const initDate =
        typeof field.answerValue === "string" ? new Date(field.answerValue) : undefined
      form = (
        <SingleDateForm
          initDate={initDate}
          minDate={new Date("1900-01-01")}
          maxDate={new Date()}
          isMaxDateToday={true}
          dateLabel={field.answerLabel}
          onComplete={async (answer: Date): Promise<boolean> => {
            await onAnswer(answer.toISOString().substring(0, 10))
            return true
          }}
          centerButtons={true}
          // onBack={() => navigate(-1)}
        />
      )
      break
    }
    case "select": {
      const options: RadioOption[] =
        field.options?.map((option: SelectOption) => {
          return {
            value: option.id || "",
            label: option.label || "",
          }
        }) || []
      form = (
        <RadioAndResponseForm
          initAnswer={field.answerValue ? field.answerValue.toString() : undefined}
          answerLabel={field.question}
          // errorText="Please select an option to continue"
          options={options}
          onComplete={async (answer: string): Promise<boolean> => {
            await onAnswer(field.interfaceType === "number" ? parseInt(answer, 10) : answer)
            return true
          }}
          centerButtons={true}
          // onBack={() => navigate(-1)}
        />
      )
      break
    }
  }
  return (
    <Box>
      {header}
      {field.learnMoreContent ? (
        <>
          <Typography
            onClick={openLearnMore}
            sx={{
              fontWeight: "800",
              cursor: "pointer",
              color: "secondary.light",
              marginTop: "0.5em",
            }}
          >
            Learn more
          </Typography>
          <AtticusDrawer
            variant="temporary"
            anchor="right"
            open={isLearnMoreVisible}
            onClose={closeLearnMore}
            contents={
              <MuiMarkdown
                overrides={{
                  ol: {
                    component: "ol",
                    props: {
                      style: { marginBottom: "0.5rem", padding: "10px 20px" },
                    },
                  },
                }}
              >
                {field.learnMoreContent}
              </MuiMarkdown>
            }
          />
        </>
      ) : null}
      {form}
    </Box>
  )
}
